import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the dashboardFilters state domain
 */

const selectDashboardFiltersDomain = state =>
  state.dashboardFilters || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by DashboardFilters
 */

const makeSelectDashboardFilters = () =>
  createSelector(
    selectDashboardFiltersDomain,
    substate => substate,
  );

export default makeSelectDashboardFilters;
export { selectDashboardFiltersDomain };
